import React from "react";
import { FormProvider } from "react-hook-form";
import {
  FormAutocomplete,
  FormCheckbox,
  FormInput,
  FormSelect,
  FormSinglePhotoPicker,
  FormAudioFilePicker,
  FormSwitch,
  FormEditor,
  FormColorPickerInput,
  FormDatePicker
} from "./components";
import { FormProps } from "./types";

const FormComponent: React.FC<FormProps> & {
  Input: typeof FormInput;
  Autocomplete: typeof FormAutocomplete;
  SinglePhotoPicker: typeof FormSinglePhotoPicker;
  AudioFilePicker: typeof FormAudioFilePicker;
  Checkbox: typeof FormCheckbox;
  Select: typeof FormSelect;
  Switch: typeof FormSwitch;
  Editor: typeof FormEditor;
  ColorPickerInput: typeof FormColorPickerInput;
  DatePicker: typeof FormDatePicker;
} = ({ methods, children, className, onSubmit, ...props }) => {

  return (
    <FormProvider {...methods}>
      <form
        className={className}
        onSubmit={methods.handleSubmit(onSubmit)}
        style={{ width: "100%" }}
        noValidate
        {...props}
      >
        {children}
      </form>
    </FormProvider>
  );
};

FormComponent.Input = FormInput;
FormComponent.Autocomplete = FormAutocomplete;
FormComponent.SinglePhotoPicker = FormSinglePhotoPicker;
FormComponent.AudioFilePicker = FormAudioFilePicker;
FormComponent.Checkbox = FormCheckbox;
FormComponent.Select = FormSelect;
FormComponent.Switch = FormSwitch;
FormComponent.Editor = FormEditor;
FormComponent.ColorPickerInput = FormColorPickerInput;
FormComponent.DatePicker = FormDatePicker;

FormComponent.Input.displayName = "Form.Input";
FormComponent.Autocomplete.displayName = "Form.Autocomplete";
FormComponent.SinglePhotoPicker.displayName = "Form.SinglePhotoPicker";
FormComponent.AudioFilePicker.displayName = "Form.AudioFilePicker";
FormComponent.Checkbox.displayName = "Form.Checkbox";
FormComponent.Select.displayName = "Form.Select";
FormComponent.Switch.displayName = "Form.Switch";
FormComponent.Editor.displayName = "Form.Editor";
FormComponent.ColorPickerInput.displayName = "Form.ColorPickerInput";
FormComponent.DatePicker.displayName = "Form.DatePicker";

export const Form = FormComponent;
